export var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["Concept"] = 1] = "Concept";
    OrderStatus[OrderStatus["In_bestelling"] = 2] = "In_bestelling";
    OrderStatus[OrderStatus["Ontvangen"] = 3] = "Ontvangen";
    OrderStatus[OrderStatus["Inkoopfactuur_verwerkt"] = 4] = "Inkoopfactuur_verwerkt";
    OrderStatus[OrderStatus["Prijs_aangevraagd"] = 5] = "Prijs_aangevraagd";
    OrderStatus[OrderStatus["Geannuleerd"] = 6] = "Geannuleerd";
    OrderStatus[OrderStatus["Retour_gestuurd"] = 7] = "Retour_gestuurd";
})(OrderStatus || (OrderStatus = {}));
export const OrderStatusMap = new Map([
    [OrderStatus.Concept, 'Concept'],
    [OrderStatus.In_bestelling, 'In bestelling'],
    [OrderStatus.Ontvangen, 'Ontvangen'],
    [OrderStatus.Inkoopfactuur_verwerkt, 'Inkoopfactuur verwerkt'],
    [OrderStatus.Prijs_aangevraagd, 'Prijs aangevraagd'],
    [OrderStatus.Geannuleerd, 'Geannuleerd'],
    [OrderStatus.Retour_gestuurd, 'Retour gestuurd']
]);
